import CardsList from "@/components/cardsList";
import { PILLARS_CONSTANTS } from "./constants";

const PillarsComponent = () => {
  return (
    <CardsList
      columns={{ base: 1, sm: 3 }}
      list={PILLARS_CONSTANTS.list}
      spacing={{ base: 8, md: 12 }}
      title={PILLARS_CONSTANTS.title}
    />
  );
};

export default PillarsComponent;
